import React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"

const ConfirmPopup = ({ isOpen, toggle, message, title, onConfirm, confirmText = "Confirm", cancelText = "Cancel" }) => (
  <Modal isOpen={isOpen} toggle={toggle} centered>
    <ModalHeader toggle={toggle} className="text-danger">
      {title}
    </ModalHeader>
    <ModalBody>
      {message || <span>An error occurred. Please try again.</span>}
    </ModalBody>
    <ModalFooter>
      <Button color="danger" onClick={toggle}>
        {cancelText}
      </Button>
      <Button color="success" style={{minWidth: "120px"}} onClick={onConfirm}>
        {confirmText}
      </Button>
    </ModalFooter>
  </Modal>
)

export default ConfirmPopup
